module.exports = __webpack_public_path__ + "img/map_11.cec51862.png";